import React from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { LoginContextProvider } from '../login/LoginHandler';
import { LoadingProvider } from '../../contexts/LoadingContext';

export type AppProvidersProps = {
  theme: any;
  msalInstance: PublicClientApplication;
  appBarExtras?: React.JSX.Element;
  appBarActions?: React.JSX.Element;
  children: React.ReactNode;
};

export function AppProviders({ theme, msalInstance, appBarExtras, appBarActions, children }: AppProvidersProps) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MsalProvider instance={msalInstance}>
        <LoginContextProvider appBarExtras={appBarExtras} appBarActions={appBarActions}>
          <LoadingProvider>
            {children}
          </LoadingProvider>
        </LoginContextProvider>
      </MsalProvider>
    </ThemeProvider>
  );
}
